import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import T6 from "../../components/ExcerciseTypes/TypeIn/T6";

const json = {

  1: { // Exercise num
    unit: 'Unit 2',
    id: 'WB3-U2-P14-E1',
    audio: '',
    video: '',
    component: D1,
    //recorder: true,
    exerciseKey: "img/FriendsPlus/Page14/E1/Key/answerKey.png",
    maxLength: 1,
    textAlign: 'center',
    padding: 0,
    isAllowSubmit: true,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page14/E1/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page14/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page14/E1/3.jpg', input: true, answer: "c" },
        { url: 'img/FriendsPlus/Page14/E1/4.jpg', input: true, answer: "o" },
        { url: 'img/FriendsPlus/Page14/E1/5.jpg', input: true, answer: "a" },
        { url: 'img/FriendsPlus/Page14/E1/6.jpg', input: true, answer: "t" },
        { url: 'img/FriendsPlus/Page14/E1/7.jpg' },
        { url: 'img/FriendsPlus/Page14/E1/8.jpg', input: true, answer: "h" },
        { url: 'img/FriendsPlus/Page14/E1/9.jpg', input: true, answer: "o" },
        { url: 'img/FriendsPlus/Page14/E1/10.jpg', input: true, answer: "o" },
        { url: 'img/FriendsPlus/Page14/E1/11.jpg', input: true, answer: "k" },
        { url: 'img/FriendsPlus/Page14/E1/12.jpg', input: true, answer: "s" },
        { url: 'img/FriendsPlus/Page14/E1/13.jpg' },
      ],
      [
        // Column1
        { url: 'img/FriendsPlus/Page14/E1/14.jpg' },
      ],
      [
        // Column1
        { url: 'img/FriendsPlus/Page14/E1/15.jpg' },
        { url: 'img/FriendsPlus/Page14/E1/16.jpg', input: true, answer: "c" },
        { url: 'img/FriendsPlus/Page14/E1/17.jpg', input: true, answer: "o" },
        { url: 'img/FriendsPlus/Page14/E1/18.jpg', input: true, answer: "m" },
        { url: 'img/FriendsPlus/Page14/E1/19.jpg', input: true, answer: "p" },
        { url: 'img/FriendsPlus/Page14/E1/20.jpg', input: true, answer: "u" },
        { url: 'img/FriendsPlus/Page14/E1/21.jpg', input: true, answer: "t" },
        { url: 'img/FriendsPlus/Page14/E1/22.jpg', input: true, answer: "e" },
        { url: 'img/FriendsPlus/Page14/E1/23.jpg', input: true, answer: "r" },
        { url: 'img/FriendsPlus/Page14/E1/24.jpg', input: true, answer: "s" },
        { url: 'img/FriendsPlus/Page14/E1/25.jpg' },
        { url: 'img/FriendsPlus/Page14/E1/26.jpg', input: true, answer: "p" },
        { url: 'img/FriendsPlus/Page14/E1/27.jpg', input: true, answer: "e" },
        { url: 'img/FriendsPlus/Page14/E1/28.jpg', input: true, answer: "n" },
        { url: 'img/FriendsPlus/Page14/E1/29.jpg', input: true, answer: "c" },
        { url: 'img/FriendsPlus/Page14/E1/30.jpg', input: true, answer: "i" },
        { url: 'img/FriendsPlus/Page14/E1/31.jpg', input: true, answer: "l" },
        { url: 'img/FriendsPlus/Page14/E1/32.jpg' },
        { url: 'img/FriendsPlus/Page14/E1/33.jpg', input: true, answer: "c" },
        { url: 'img/FriendsPlus/Page14/E1/34.jpg', input: true, answer: "a" },
        { url: 'img/FriendsPlus/Page14/E1/35.jpg', input: true, answer: "s" },
        { url: 'img/FriendsPlus/Page14/E1/36.jpg', input: true, answer: "e" },
        { url: 'img/FriendsPlus/Page14/E1/37.jpg', input: true, answer: "s" },
        { url: 'img/FriendsPlus/Page14/E1/38.jpg' },

      ],
      [
        // Column1
        { url: 'img/FriendsPlus/Page14/E1/39.jpg' },

      ],
      [
        // Column1
        { url: 'img/FriendsPlus/Page14/E1/40.jpg' },
        { url: 'img/FriendsPlus/Page14/E1/41.jpg', input: true, answer: "b" },
        { url: 'img/FriendsPlus/Page14/E1/42.jpg', input: true, answer: "o" },
        { url: 'img/FriendsPlus/Page14/E1/43.jpg', input: true, answer: "a" },
        { url: 'img/FriendsPlus/Page14/E1/44.jpg', input: true, answer: "r" },
        { url: 'img/FriendsPlus/Page14/E1/45.jpg', input: true, answer: "d" },
        { url: 'img/FriendsPlus/Page14/E1/46.jpg' },
      ],
      [
        // Column1
        { url: 'img/FriendsPlus/Page14/E1/46.jpg' },
      ],
      [
        // Column1
        { url: 'img/FriendsPlus/Page14/E1/46.jpg' },
      ],

    ],
  },
  2: {
    // Exercise num
    unit: 'Unit 2',
    id: 'WB3-U2-P14-E2',
    audio: "",
    video: "",
    component: T6,
    exerciseKey: "img/FriendsPlus/Page14/E2/Key/answerKey.png",
    inputSize: 200,
    titleImage: "",
    titleQuestion: [{ color: '#3F3478', num: '2', title: "Look again and write." }],
    questionImage: [],
    questions: [
      {
        title: `
          <div >
              <div><b>1</b> There is a new <u style='color: gray;'><i>table</i></u></div>
              <div><b>2</b> There are new #</div>
              <div><b>3</b> There are new # </div>
              <div><b>4</b> There are new # </div>
              <div><b>5</b> There is a new # </div>
          </div>
        `,
        answer: ["coat hooks", "computers", "pencil cases", "board"],
      },
    ],
  },
}

export default json;